export class ResponseError extends Error {
    public errors: {[property: string]: string[]};

    constructor(errors: {[property: string]: string[]}, message: string) {
        super(message);

        this.errors = errors;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ResponseError.prototype);
    }
}

export class CartNotFoundError extends Error {
    constructor(message: string) {
        super(message);

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, CartNotFoundError.prototype);
    }
}